import { del, ensureSiAdmin, useTranslate } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';
import { useUser } from './useUser';

interface Params {
  inviteId: string;
}

export function useDeleteInvite() {
  const queryClient = useQueryClient();
  const { user } = useUser();
  const { t, translate } = useTranslate();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: ({ inviteId }: Params) => {
      ensureSiAdmin(user, translate(t.adminAccessRequired));
      return del({
        url: `/api/admin/invites/${inviteId}`,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.getInvites,
      });
    },
  });

  const deleteInvite = useCallback((params: Params) => mutate(params), [mutate]);

  return {
    deleteInvite,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
